var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 12,
    fill: "#767BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5094 26.4285C44.3404 27.9461 44.9655 29.5761 45.3453 31.2684C48.7192 33.0115 51.0571 36.4979 51.0571 40.5543C51.0571 46.358 46.3608 51.0543 40.5571 51.0543C34.7534 51.0543 30.0571 46.358 30.0571 40.5543C30.0571 36.0729 32.8872 32.2609 36.8559 30.7516C37.5531 32.1666 37.9223 33.7252 37.9329 35.3043C37.9329 38.3698 36.5893 41.108 34.4876 43.0251C35.0003 44.2761 35.8928 45.3318 37.0306 46.0602C40.7015 42.7995 42.4553 37.8875 41.6859 33.0419C40.9168 28.1815 37.7279 24.0595 33.2285 22.0907L36.6229 16.6561L32.0661 13H22.7965L18.2438 16.6602L21.6276 22.0948C15.3834 24.8453 11.9069 31.5883 13.3118 38.2738C14.7168 44.9594 20.6028 49.7418 27.4294 49.75C28.0549 49.7397 28.6804 49.6987 29.3063 49.5962C33.2848 54.5591 40.0524 56.3334 45.9586 53.9537C51.855 51.5854 55.5071 45.6193 54.9411 39.2783C54.375 32.9373 49.7356 27.7246 43.5094 26.4285ZM23.4938 17.5421L24.1911 16.9371H30.6715L31.3688 17.5421L29.277 21.0079C28.0564 20.8336 26.8054 20.8336 25.5856 21.0079L23.4938 17.5421ZM16.9313 35.2387C16.9416 29.4456 21.6383 24.7469 27.4313 24.7387C30.1383 24.7387 32.5894 25.7952 34.4556 27.4867C29.5436 29.7836 26.1213 34.7055 26.1213 40.4887C26.1213 42.2729 26.4596 44.0472 27.1056 45.7083C21.4758 45.6074 16.9313 40.9891 16.9313 35.2387Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingIcon);
export default __webpack_public_path__ + "static/media/ring-icon.48724b84590301cd3ac4b39b1debc413.svg";
export { ForwardRef as ReactComponent };